import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { InputLabel } from '@material-ui/core';
import { EditableQuestion } from '../../../../../../types';
import { cutLongText } from '../../../../../../../../helpers';
import { StyledQuestionFieldContainer } from '../../styles';
import { ErrorMessage } from '../../../../../../../Services/styled-components';
import ReactSelect from 'react-select';

interface Props {
  control: Control<EditableQuestion>;
  mainQuestions: EditableQuestion[];
}

const MainQuestionEditor = ({ control, mainQuestions }: Props) => {
  console.log('MainQuestionEditor received questions:', mainQuestions.length);
  console.log('MainQuestionEditor questions:', mainQuestions.map(q => q.question));
  
  return (
    <Controller
      control={control}
      name="parent_question_id"
      rules={{
        required: { value: true, message: 'Main question is required' }
      }}
      render={({ field: { ref, ...field }, formState }) => (
        <StyledQuestionFieldContainer>
          <InputLabel>Parent Question</InputLabel>
          <ReactSelect<{ value: string }>
            options={mapQuestionsToOptions(mainQuestions)}
            onChange={(newValue) => newValue && field.onChange(newValue.value)}
            value={findSelectedOption(mainQuestions, field.value)}
          />
          <ErrorMessage>{formState.errors.parent_question_id?.message}</ErrorMessage>
        </StyledQuestionFieldContainer>
      )}
    />
  );
};

function findSelectedOption(questions: EditableQuestion[], selectedId?: string | null) {
  if (!selectedId) return null;
  const selectedQuestion = findQuestionById(questions, selectedId);
  return selectedQuestion ? mapQuestionToOption(selectedQuestion) : null;
}

function findQuestionById(questions: EditableQuestion[], id: string) {
  return questions.find((question) => question._id === id);
}

function mapQuestionsToOptions(questions: EditableQuestion[]) {
  return questions.map(mapQuestionToOption);
}

function mapQuestionToOption(question: EditableQuestion) {
  return {
    value: question._id,
    label: cutLongText(question.question, 50)
  };
}

export default MainQuestionEditor;
